import { useContext } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { startDownloadFile } from 'src/common/helpers';

import { handleHotKeysEvent } from 'src/common/helpers/analyticsEvents';
import { actions, CatalogContext } from 'src/contexts/Catalog';

export const useKeyboardNavigation = () => {
  const [state, dispatch] = useContext(CatalogContext);

  useHotkeys('Alt+9', () => {
    handleHotKeysEvent('9');
    dispatch(actions.goToPreviousPage());
  });

  useHotkeys('Alt+0', () => {
    handleHotKeysEvent('0');
    dispatch(actions.goToNextPage());
  });

  useHotkeys('Alt+3', () => {
    handleHotKeysEvent('3');
    startDownloadFile(state.catalogData.pdf);
  });
};
